import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase I (I-B, I2): Settings → Subscription (tenant administrators) and Settings → Plans
// (platform admins), nested under the admin layout in modules/admin/routes.tsx.
export const routes: RouteObject[] = [];
export const orgRoutes: RouteObject[] = [];

export const settingsRoutes: RouteObject[] = [
  { path: 'subscription', lazy: page(() => import('./subscription-page'), (m) => m.SubscriptionPage) },
];
